var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGlobalProcurement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.23926,40.00537A16.75537,16.75537,0,1,0,39.99512,23.25,16.77425,16.77425,0,0,0,23.23926,40.00537ZM45.967,54.04028A14.6584,14.6584,0,0,0,49.001,48.75h3.47436A15.33782,15.33782,0,0,1,45.967,54.04028ZM53.416,47.25H49.45923a27.79542,27.79542,0,0,0,.87085-6.49463h4.88183A15.14854,15.14854,0,0,1,53.416,47.25Zm1.79589-7.99463H50.33032A27.76874,27.76874,0,0,0,49.45776,32.75h3.95313A15.14867,15.14867,0,0,1,55.21191,39.25537ZM52.46753,31.25H48.99878A14.646,14.646,0,0,0,45.969,25.97095,15.33743,15.33743,0,0,1,52.46753,31.25ZM40.74512,24.80884c2.85742.35913,5.217,2.74975,6.63867,6.44116H40.74512Zm0,7.94116H47.884a25.54752,25.54752,0,0,1,.94678,6.50537H40.74512Zm0,8.00537h8.08545A25.58424,25.58424,0,0,1,47.88574,47.25H40.74512Zm0,7.99463h6.64135c-1.42114,3.69727-3.782,6.0918-6.64135,6.45142Zm-14.16675-16h3.9541a27.76874,27.76874,0,0,0-.87256,6.50537H24.77734A15.14868,15.14868,0,0,1,26.57837,32.75Zm-1.801,8.00537h4.88282A27.79436,27.79436,0,0,0,30.531,47.25H26.57324A15.14855,15.14855,0,0,1,24.77734,40.75537ZM27.51392,48.75h3.47534a14.65578,14.65578,0,0,0,3.03442,5.29077A15.338,15.338,0,0,1,27.51392,48.75Zm11.7312,6.45142c-2.85938-.35962-5.22022-2.75415-6.64136-6.45142h6.64136Zm0-7.95142H32.10449a25.58381,25.58381,0,0,1-.94482-6.49463h8.08545Zm0-7.99463h-8.0857A25.548,25.548,0,0,1,32.1062,32.75h7.13892Zm0-14.44653V31.25H32.60645C34.02808,27.55859,36.3877,25.168,39.24512,24.80884Zm-5.22364,1.16162a14.64648,14.64648,0,0,0-3.03,5.27954H27.522A15.33811,15.33811,0,0,1,34.02148,25.97046Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36,61.25a.7502.7502,0,0,0-.75.75v8a.7502.7502,0,0,0,.75.75h8a.7502.7502,0,0,0,.75-.75V62a.7502.7502,0,0,0-.75-.75Zm7.25,8h-6.5v-6.5h2.5V66h1.5V62.75h2.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44,18.75a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,44,9.25H36a.7502.7502,0,0,0-.75.75v8a.7502.7502,0,0,0,.75.75Zm-7.25-8h6.5v2.5h-6.5Zm0,4h6.5v2.5h-6.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 16,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 16,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 30,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 30,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 40,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 64,
    r: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 64,
    r: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 50,
    r: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 40.00513,
    r: 1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 22,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobalProcurement);
export default __webpack_public_path__ + "static/media/icon_global_procurement.32a0b66008ef245e1b5dd7dfb159dc74.svg";
export { ForwardRef as ReactComponent };